import { Component, Input, OnChanges, ViewChild, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IBasket } from '@bdeo-platform/private-api';
import { BdeoDrawer, BdeoSelectOption, BdeoToastService } from '@bdeo/webcomponents';
import { I18NEXT_SERVICE } from 'angular-i18next';
import { SmartphotoService } from '../../../../services/smartphoto.service';
import { Company, Smartphoto } from '@bdeo-motor/smartphoto-entities';

@Component({
  selector: 'app-smartphoto-basket-edit-drawer',
  templateUrl: './smartphoto-basket-edit-drawer.component.html',
  styleUrl: './smartphoto-basket-edit-drawer.component.scss'
})
export class SmartphotoBasketEditDrawerComponent implements OnChanges {
  @ViewChild('drawer') drawer!: { nativeElement: BdeoDrawer };
  @Input() public smartphoto?: Smartphoto;
  @Input() public company?: Company;

  private readonly i18next = inject(I18NEXT_SERVICE);
  private readonly smartphotoService = inject(SmartphotoService);

  protected isSaving = false;
  protected selectedBasket: FormControl<string | null>;
  protected basketForm: FormGroup;
  protected basketOptions: BdeoSelectOption[] = [
    {
      text: this.i18next.t('brokers:baskets.title_manual-revision'),
      value: 'manual-revision',
      disabled: false,
      selected: false
    },
    {
      text: this.i18next.t('brokers:baskets.title_automatic'),
      value: 'automatic',
      disabled: false,
      selected: false
    }
  ];

  private readonly defaultBaskets: IBasket[] = [
    {
      name: 'manual-revision',
      description: '',
      flags: [],
      priority: 0
    },
    {
      name: 'automatic',
      description: '',
      flags: [],
      priority: 0
    }
  ];

  constructor() {
    this.selectedBasket = new FormControl(null);
    this.basketForm = new FormGroup({
      selectedBasket: this.selectedBasket
    });
  }

  public ngOnChanges(): void {
    if (!this.smartphoto) {
      return;
    }

    if (this.company?.baskets) {
      this.basketOptions = (this.company.baskets.get() ?? []).map((basket) => ({
        value: basket.name,
        text: basket.name,
        disabled: false,
        selected: false
      }));
    }
    if (this.smartphoto?.basket) {
      this.selectedBasket.setValue(this.smartphoto.basket.name);
    }
  }

  protected async save(): Promise<void> {
    if (!this.smartphoto) {
      return;
    }

    this.isSaving = true;
    this.smartphoto.basket = (this.company?.baskets?.get() ?? this.defaultBaskets).find(
      (basket) => basket.name === this.selectedBasket.value
    );
    try {
      await this.smartphotoService.update.basket();
      this.close();
      BdeoToastService.success(this.i18next.t('brokers:success_update_smartphoto'));
    } catch (e: unknown) {
      BdeoToastService.error(this.i18next.t('brokers:errors.update_damages'));
    } finally {
      this.isSaving = false;
    }
  }

  public open(): void {
    this.drawer.nativeElement.show = true;
  }

  public close(): void {
    this.drawer.nativeElement.show = false;
  }
}
